"use client";

import { pagesSchema } from "../../../lib/types/schema/pagesSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyPages } from "./keyPages";

export type UseRequestPagesProps = UseRequestQueryProps & {
  page: string;
};

export const useRequestPages = ({ page, ...props }: UseRequestPagesProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: pagesSchema,
      urlBackendPath: `/pages/${page}`,
    },
    queryKey: keyPages({ page }),
  }),
});
